import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { GeckoBtn } from 'ui';

import './index.scss';

class StepContainer extends Component {
  static propTypes = {
    stepNumber: PropTypes.number,
    name: PropTypes.string,
    stepState: PropTypes.oneOf(['incomplete', 'complete', 'in-progress']),
    children: PropTypes.element,
    onNext: PropTypes.func,
    onSetLive: PropTypes.func,
    onClick: PropTypes.func,
    expanded: PropTypes.bool,
    nextDisabled: PropTypes.bool,
  };

  static defaultProps = {
    expanded: false,
    stepState: 'incomplete',
    onNext: () => {},
    onClick: () => {},
  };

  getIcon() {
    const icons = {
      incomplete: 'far fa-ellipsis-h',
      complete: 'far fa-check',
      'in-progress': 'far fa-ellipsis-h',
    };
    return icons[this.props.stepState];
  }

  renderContent() {
    if (!this.props.expanded) {
      return null;
    }
    return (
      <div className="StepContainer-content">
        {this.props.expanded ? this.props.children : null}
      </div>
    );
  }

  renderFooter() {
    if (!this.props.expanded) {
      return null;
    }
    return (
      <div className="StepContainer-footer">
        {this.props.onSetLive ? (
          <GeckoBtn
            name="Set Live"
            type="primary"
            icon="far fa-check-double"
            handler={this.props.onSetLive}
            disabledWhen={() => this.props.nextDisabled}
          />
        ) : (
          <GeckoBtn
            name="Next Step"
            type="primary"
            iconRight="far fa-angle-right"
            handler={this.props.onNext}
            disabledWhen={() => this.props.nextDisabled}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="StepContainer">
        <div className="StepContainer-header" onClick={this.props.onClick}>
          <div className="StepContainer-number">{this.props.stepNumber}</div>
          <div className="StepContainer-name">{this.props.name}</div>
          <div className={`StepContainer-indicator ${this.props.stepState}`}>
            <i className={`${this.getIcon()}`}></i>
          </div>
        </div>
        {this.renderContent()}
        {this.renderFooter()}
      </div>
    );
  }
}

export default StepContainer;
